import React from 'react';
import { createRoot } from 'react-dom/client';
import 'tailwindcss/tailwind.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import App from 'App';
// import AxiosInterceptor from 'interceptors/axios.interceptor';
import { store } from 'store/store';
import { persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';

const queryClient = new QueryClient();
const persistor = persistStore(store);

const container = document.getElementById('root') as HTMLDivElement;
const root = createRoot(container);

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter basename={import.meta.env.BASE_URL}>
          <React.StrictMode>
            {/* <AxiosInterceptor> */}
            <App />
            {/* </AxiosInterceptor> */}
          </React.StrictMode>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </QueryClientProvider>
);
